/**
 * Lalay Checkout API — wraps /wp-json/lalay/v1/{stripe,checkout,orders}.
 * Mirrors the auth.js style (Bearer token from localStorage).
 */

import { getToken } from './auth';

const BASE = '/wp-json/lalay/v1';

async function call(path, opts = {}) {
  const headers = { 'Content-Type': 'application/json', ...(opts.headers || {}) };
  const tok = getToken();
  if (tok && !headers.Authorization) headers.Authorization = `Bearer ${tok}`;
  const res = await fetch(`${BASE}${path}`, { ...opts, headers });
  const text = await res.text();
  let body;
  try { body = text ? JSON.parse(text) : {}; } catch { body = { success: false }; }
  return { ok: res.ok, status: res.status, body };
}

export async function getStripeConfig() {
  const { status, body } = await call('/stripe/config');
  if (status === 200 && body.success) return body;
  return null;
}

export async function createPaymentIntent({ cartItems }) {
  const { status, body } = await call('/stripe/create-payment-intent', {
    method: 'POST',
    body: JSON.stringify({ cart_items: cartItems }),
  });
  if (status === 200 && body.success) return body;
  return { error: body.message || 'Could not initialize payment', code: body.code, status };
}

export async function completeCheckout({ paymentIntentId, cartItems, billingAddress, shippingAddress }) {
  const { status, body } = await call('/checkout', {
    method: 'POST',
    body: JSON.stringify({
      payment_intent_id: paymentIntentId,
      cart_items: cartItems,
      billing_address: billingAddress,
      shipping_address: shippingAddress,
    }),
  });
  if (status === 200 && body.success) return body;
  return { error: body.message || 'Could not place order', code: body.code, status };
}

export async function fetchOrders() {
  const { status, body } = await call('/orders');
  if (status === 200 && body.success) return body.orders || [];
  return [];
}

export async function fetchOrder(id) {
  const { status, body } = await call('/orders/' + Number(id));
  if (status === 200 && body.success) return body.order;
  return null;
}
